export interface IReceiptV2 {
  officeId: string;
  officeName: string;
  shiftDate: string;
  shiftId: string;
  status: ReceiptV2Status;
  totalCharge: number;
  totalRefund: number;
  transactionDate: string;
}

export enum ReceiptV2Status {
  Pending = 'Pending',
  Refunded = 'Refunded',
  Successful = 'Successful',
}
